export enum TimeslotErrors {
  NotFoundDB = "Timeslot not found in database",
}
